import type { Mark as MarkValue } from '@/domain/prayer';
import { markClasses } from '@/domain/prayer';

/**
 * The four-quality mark. Segments run top, right, bottom, left in the fixed
 * order prayed / in its time / jamā‘ah / first takbīrah — position is the
 * encoding, colour reinforces it.
 */
export function Mark({
  mark,
  size = 28,
  className = '',
}: {
  mark: MarkValue;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={`seg ${markClasses(mark)} ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <path className="s1" d="M16.96 5.04 A 11 11 0 0 1 26.96 15.04" />
      <path className="s2" d="M26.96 16.96 A 11 11 0 0 1 16.96 26.96" />
      <path className="s3" d="M15.04 26.96 A 11 11 0 0 1 5.04 16.96" />
      <path className="s4" d="M5.04 15.04 A 11 11 0 0 1 15.04 5.04" />
    </svg>
  );
}
